import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import About from "./About";
import Project from "./Project";
import Skills from "./Skills";
import Blog from "./Blog";
import Footer from "./Footer";

const Layout = () => {
  const [cTheme, setTheme] = useState("light");

  useEffect(() => {
    const th = localStorage.getItem("theme");
    if (th) {
      setTheme(th);
    } else {
      setTheme("light");
    }
  }, []);

  const toggleTheme = () => {
    if (cTheme === "light") {
      setTheme("dark");
      localStorage.setItem("theme", "dark");
    } else {
      setTheme("light");
      localStorage.setItem("theme", "light");
    }
  };

  return (
    <>
      <Sidebar changeTheme={toggleTheme} activeTheme={cTheme} />
      <div className="content_part">
        <About />
        <Skills />
        <Project />
        <Blog />
        <Footer />
      </div>
    </>
  );
};

export default Layout;
